import { render } from "./AiBriefDetail.vue?vue&type=template&id=c94678d6&scoped=true"
import script from "./AiBriefDetail.vue?vue&type=script&lang=js"
export * from "./AiBriefDetail.vue?vue&type=script&lang=js"

import "./AiBriefDetail.vue?vue&type=style&index=0&id=c94678d6&lang=css"
import "./AiBriefDetail.vue?vue&type=style&index=1&id=c94678d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94678d6"]])

export default __exports__